import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "question-content-show d-flex flex-column" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 0,
  id: "editor",
  class: "markdown-editor w-full",
  style: {"min-height":"560px"}
}

import QuestionRadio from './QuestionRadio.vue'
import QuestionCheckBox from './QuestionCheckBox.vue'
import QuestionSelect from './QuestionSelect.vue'
import ProgressQuestion from './ProgressQuestion.vue'
import Simplemde from './Simplemde.vue'
import { useExamTestQuestionBody } from './useExamTestQuestionBody'
import Question from '../../models/question'
import Exam from '../../models/exam'


export default /*@__PURE__*/_defineComponent({
  __name: 'ExamTestQuestionBodyWeb',
  props: {
    exam: {},
    currentQuestion: {},
    index: {},
    time: {}
  },
  emits: ["changeValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const {
  value,
  text,
  show,
  radioValue,
  content,
  textareaOnChange,
  callBackChange,
  callBackChangeOne,
  getAnswerMode
} = useExamTestQuestionBody(props, emit)

return (_ctx: any,_cache: any) => {
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_v_card_title = _resolveComponent("v-card-title")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_layout, null, {
      default: _withCtx(() => [
        (_unref(show))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "question-body-preview-client p-4",
              innerHTML: _unref(content)
            }, null, 8 /* PROPS */, _hoisted_2))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }),
    (!__props.currentQuestion.isDescriptionQuestion)
      ? (_openBlock(), _createBlock(_component_v_card_title, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_v_layout, null, {
              default: _withCtx(() => [
                _createCommentVNode(" Use DOm when question is Text field "),
                (_unref(getAnswerMode)() && _unref(show))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3))
                  : (__props.currentQuestion.isTextarea && _unref(show))
                    ? (_openBlock(), _createBlock(Simplemde, {
                        key: `markdownEditor_q_${__props.currentQuestion.id}`,
                        name: `markdownEditor_q_${__props.currentQuestion.id}`,
                        ref: `markdownEditor_q_${__props.currentQuestion.id}`,
                        modelValue: _unref(text),
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(text) ? (text).value = $event : null)),
                        rows: __props.currentQuestion.textareaRowNumber,
                        onInput: _unref(textareaOnChange),
                        "preview-class": "markdown-body",
                        class: "w-full"
                      }, null, 8 /* PROPS */, ["name", "modelValue", "rows", "onInput"]))
                    : (__props.currentQuestion.isCheckbox || __props.currentQuestion.isMultiCheckbox)
                      ? (_openBlock(), _createBlock(QuestionCheckBox, {
                          key: 2,
                          list: __props.currentQuestion.answerItemsView ? __props.currentQuestion.answerItemsView : [],
                          callBackChange: _unref(callBackChange),
                          value: _unref(value) ? _unref(value) : [],
                          readonly: __props.time === 0,
                          color: "white"
                        }, null, 8 /* PROPS */, ["list", "callBackChange", "value", "readonly"]))
                      : (__props.currentQuestion.isRadio)
                        ? (_openBlock(), _createBlock(QuestionRadio, {
                            key: 3,
                            list: __props.currentQuestion.answerItemsView ? __props.currentQuestion.answerItemsView : [],
                            callBackChange: _unref(callBackChangeOne),
                            value: _unref(radioValue),
                            readonly: __props.time === 0,
                            color: "white"
                          }, null, 8 /* PROPS */, ["list", "callBackChange", "value", "readonly"]))
                        : (__props.currentQuestion.isSelect)
                          ? (_openBlock(), _createBlock(QuestionSelect, {
                              key: 4,
                              list: __props.currentQuestion.answerItemsView ? __props.currentQuestion.answerItemsView : [],
                              callBackChange: _unref(callBackChange),
                              value: _unref(value) ? _unref(value) : [],
                              readonly: __props.time === 0,
                              color: "white"
                            }, null, 8 /* PROPS */, ["list", "callBackChange", "value", "readonly"]))
                          : _createCommentVNode("v-if", true)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})